// == home page section =======
import Hero from "./Hero"
import About from "./About"
import Factions from "./Factions"
import RoadMap from "./RoadMap"


// ****** Home page wrapper main ******
const Home = () => {
  return (
    <main>
      <Hero />
      <About />
      <RoadMap />
      <Factions />
      {/* merch and stake buttons */}
      {/* <section id="btns">
        <div className="cs_container">
          <br />
          <div className="cs_row align-items-center justify-content-center">
          http://staking.spacewarriorsclub.com/
            <a title="Coming soon" href="javascript:void(0)" className="cta-btn">
              <div className="div-hide">
                <div className="cta-btn-text">Soon!</div>
                <div className="cta-btn-top-text">Stake</div>
              </div>
            </a>
            <a href="http://merch.spacewarriorsclub.com/" target="_blank" rel="noopener noreferrer" className="cta-btn">
              <div className="div-hide">
                <div className="cta-btn-text">Merch</div>
                <div className="cta-btn-top-text">Merch</div>
              </div>
            </a>
          </div>
          <br />
        </div>
      </section> */}
    </main>
  )
}

export default Home